<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.sub_user_information')}}</h3>
            <div class="card-toolbar">
              <b-button-group>
                <b-button><i class="far fa-file-alt mr-2"></i> {{$t('user_detail.report')}}</b-button>
                <b-dropdown right :text="$t('user_detail.user_type')">
                  <b-dropdown-item v-for="user_type in user_types" :key="user_type">
                    {{ user_type }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-button-group>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">

            <div class="fa-pull-right">
              <label class="mr-3">Toplam Kullanıcı Sayısı :</label>
              <strong>48</strong>
              <hr>
            </div>

            <data-table
                :items="table.items"
                :fields="report.fields"
                :paginate="report.paginate"
                :responsive="table.responsive"
                page.sync="3"
                perPage.sync="10"
            ></data-table>

          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "SubUsers",
  components: {DataTable},
  data() {
    return {
      form : {
        user_type: null,
      },
      user_types: [
          'Yeni Üye',
          'Aktif Üye',
          'Pasif Üye',
          'Fraud Yapan Üye',
          'Fraud Üyelik',
          'Çöp',
          "ST'de Silinmeyi İsteyen",
          "Napolyon'da Silinmeyi İsteyen",
      ],
      table : {
        responsive : true,
        items : [
          {'member_id' : '3871304', 'ref_no' : '189485', 'firstname' : 'Serdar', 'lastname' : 'Mermer', 'gender' : 'Erkek', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871305', 'ref_no' : '309788', 'firstname' : 'Utku', 'lastname' : 'Kurtkulağı', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871306', 'ref_no' : '861329', 'firstname' : 'Burcu', 'lastname' : 'Müfit', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com','actions' : ''},
          {'member_id' : '3871307', 'ref_no' : '229893', 'firstname' : 'Hüsniye', 'lastname' : 'Tutar', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871308', 'ref_no' : '553845', 'firstname' : 'Rıza', 'lastname' : 'Bel', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871309', 'ref_no' : '971095', 'firstname' : 'Ali', 'lastname' : 'Evren', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871310', 'ref_no' : '415621', 'firstname' : 'Emre', 'lastname' : 'Duran', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871311', 'ref_no' : '531929', 'firstname' : 'Elmas', 'lastname' : 'Yıldız', 'gender' : 'Kadın', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871312', 'ref_no' : '137661', 'firstname' : 'Hamit', 'lastname' : 'Can', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871313', 'ref_no' : '439303', 'firstname' : 'Müge', 'lastname' : 'Ateş', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com','actions' : ''},
          {'member_id' : '3871314', 'ref_no' : '371977', 'firstname' : 'Oğuz', 'lastname' : 'Aslan', 'gender' : 'Erkek', 'status' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871315', 'ref_no' : '575361', 'firstname' : 'Sinan', 'lastname' : 'Yıldırım', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871316', 'ref_no' : '786962', 'firstname' : 'Büşra', 'lastname' : 'Demir', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871317', 'ref_no' : '198541', 'firstname' : 'Yelda', 'lastname' : 'Özbakır', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871318', 'ref_no' : '736432', 'firstname' : 'Rüzgar', 'lastname' : 'Kanca', 'gender' : 'Erkek', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
          {'member_id' : '3871319', 'ref_no' : '689660', 'firstname' : 'Murat', 'lastname' : 'Toptan', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com', 'actions' : ''},
        ],
      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 10,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'member_id', label: 'Member ID', sortable: false},
          {key: 'ref_no', label: 'Ref No', sortable: true},
          {key: 'firstname', label: 'Ad', sortable: true},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'gender', label: 'Cinsiyet', sortable: true},
          {key: 'd_date', label: 'D. Tarihi', sortable: true},
          {key: 'location', label: 'Oturduğu İl', sortable: true},
          {key: 'register_date', label: 'Kayıt Tarihi', sortable: true},
          {key: 'email', label: 'E-Posta', sortable: true},
          {key: 'user_action', label: 'İşlem', sortable: true},
        ],
      },

    }
  },
};
</script>
